export const trackLead = ({ formName, service = "", leadType = "Contact Form" }) => {
  if (typeof window === "undefined") return;

  if (typeof window.gtag !== "function") return;

  window.gtag("event", "generate_lead", {
    form_name: formName,
    lead_type: leadType,
    service,
    page_title: document.title,
    page_location: window.location.href,
    page_path: window.location.pathname,
  });
};
